import { render, staticRenderFns } from "./BaseIndicatorOverview.vue?vue&type=template&id=94e52c90&"
import script from "./BaseIndicatorOverview.vue?vue&type=script&lang=js&"
export * from "./BaseIndicatorOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports